import React from 'react';
import { connect } from 'react-redux';
import { Title3, Caption1, Callout } from '../Typography';
import styled from 'styled-components';
import { navigate } from 'gatsby';
import { showPaymentMethodForm } from '../../modules/PaymentMethods/paymentMethodsActions';
import { isNullableType } from 'graphql';
import appConfig from '../../../app-config';

const Wrapper = styled.div`
  padding-left: ${(props) => (props.isForCheckoutPage ? '80px' : '0')};
  font-family: ${(props) => props.theme.primaryFontFontFamily};
  @media (max-width: 786px) {
    padding-left: 0;
  }
  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
    transition: all 0.25s ease;
  }
`;
const ButtonTextWrapper = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: inherit;
`;

const ButtonWrapper = styled.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: auto auto;
  align-items: center;
  justify-self: center;
  cursor: pointer;
  border: solid 2px #dbdbdb;
  padding: 19px 16px 19px 24px;
  border-radius: 6px;
  width: 100%;
  border-color: ${(props) => props.theme.addCreditCardBorderColor || '#000000'};
  color: ${(props) => props.theme.addCreditCardBorderColor || '#000000'};
  &:hover {
    border-color: ${(props) =>
      props.theme.addCreditCardBorderColorHover || '#000000'};
    color: ${(props) => props.theme.addCreditCardBorderColorHover || '#000000'};
    transition: all 0.25s ease;
  }
`;

const ChangeButton = styled(Caption1)`
  cursor: pointer;
  justify-self: flex-end;
  margin-top: 12px;
  color: ${(props) => props.color || props.theme.clickableTextColor};

  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
    transition: all 0.25s ease;
  }
`;

const CalloutWrapper = styled(Callout)`
  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
    transition: all 0.25s ease;
  }
`;

const AddNewPaymentMethodButton = ({
  showPaymentMethodForm,
  isForCheckoutPage,
  noDialogBackground,
  showChangePaymentMethodButton,
  showSelectPaymentMethodForm,
}) => {
  return (
    <Wrapper isForCheckoutPage={isForCheckoutPage}>
      <ButtonWrapper
        id="AddPaymentMethodButton"
        onClick={() =>
          isForCheckoutPage
            ? navigate('/payment-methods')
            : showPaymentMethodForm(noDialogBackground)
        }
      >
        <ButtonTextWrapper>+ Add a Payment Method</ButtonTextWrapper>
        <div style={{ textAlign: 'right' }}>
          {appConfig.appSource == 'iQ' ? (
            <img src="https://cdn.zeplin.io/5eecf39877a3e0469ce04a0d/assets/9A93FA75-871A-4BC8-B6D4-A2B5444EF869.svg" />
          ) : (
            <i
              className="fas fa-credit-card-blank"
              style={{
                fontSize: '29px',
                color: 'inherit',
              }}
            />
          )}
        </div>
      </ButtonWrapper>
      {showChangePaymentMethodButton ? (
        <ChangeButton
          id="CartPaymentMethod-ChangeButton"
          onClick={() => showSelectPaymentMethodForm(true)}
          style={{ alignContent: 'flex-end' }}
        >
          <CalloutWrapper>Change</CalloutWrapper>
        </ChangeButton>
      ) : null}
    </Wrapper>
  );
};

export default connect(null, { showPaymentMethodForm })(
  AddNewPaymentMethodButton
);
